"use client";

import { useSearchParams } from "next/navigation";

export function LeaguesAction({ label, value, className }: { label: string; value: string; className?: string }) {
  const searchParams = useSearchParams();
  const league = searchParams.get("league") ?? "";
  const params = new URLSearchParams(searchParams.toString());
  value ? params.set("league", value) : params.delete("league");

  return (
    <input
      type="radio"
      name="options"
      value={value}
      key={value}
      aria-label={label}
      className={`${className} ${value === league || "btn-outline"}`}
      onClick={() => window.history.replaceState(null, "", `?${params.toString()}`)}
    />
  );
}
